// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DoughnutChart_wrapper__PouTs","item":"DoughnutChart_item__2CbWx","chart":"DoughnutChart_chart__1HVxE","load":"DoughnutChart_load__2HS9L"};